import { EHoldTypes } from '@/enums/EHoldTypes';
import { removeTimeZoneOffset } from '@/util/class-transformer/removeTimeZoneOffset';
import { Type, Transform, plainToClass } from 'class-transformer';
import { BaseCandidate } from '../BaseCandidate';

export class Hold {
  @Type(/* istanbul ignore next */ () => Number)
  candidateId!: number;
  @Type(/* istanbul ignore next */ () => BaseCandidate)
  candidate!: BaseCandidate;
  firstName!: string | null;
  lastName!: string | null;
  flightPayHoldtype!: EHoldTypes | null;
  @Type(/* istanbul ignore next */ () => Number)
  days!: number | null;
  @Type(/* istanbul ignore next */ () => Date)
  @Transform(
    /* istanbul ignore next */ ({ value }) => removeTimeZoneOffset(value)
  )
  orderEndDate!: Date | null;

  constructor(partial?: Partial<Hold>) {
    if (partial) {
      Object.assign(this, plainToClass(Hold, partial));
    }
  }
}
